import { accessRowToFieldId } from '../helpers';

/**
 * Return unqiue array of SubMenuNames.
 *
 * @param {string} root
 * @param {array} data
 */
export const extractSubMenuOptionsByRoot = (root, data) => {
  return [
    ...new Set(
      data
        .filter(item => item.GroupName === root)
        .map(item => item.SubGroupName)
    ),
  ].map(item => ({
    key: item,
    value: item,
    text: item,
  }));
};

/**
 * @param {Array} data
 * @return {Array}
 */
export const extractPreferences = (data = []) => {
  let preferences = [];

  data
    .filter(item => item.Preferences !== undefined && !!item.Preferences.length)
    .forEach(item => {
      preferences = preferences.concat(item.Preferences);
    });

  return preferences;
};

/**
 * If the GroupName matches the SubGroupName
 * the data item does not have a valid SubGroupName.
 * If SubGroupName is invalid clear the value.
 *
 * @param {Array} data
 */
export const filterMissingSubGroupName = data => {
  return data.map(item => {
    if (item.GroupName !== item.SubGroupName) return item;

    return {
      ...item,
      SubGroupName: null,
    };
  });
};

/**
 * @param {Array} originalData
 * @param {Object} formValues
 * @return {Object}
 */
export const convertFormValuesForAPI = (originalData, formValues) => {
  const { roleId } = formValues;

  let data = {
    roleId,
    accessInfoValues: [],
  };

  originalData.forEach(item => {
    const Id = accessRowToFieldId(item);
    let updatedItem = {};

    if (formValues[`AllowRead${Id}`]) {
      updatedItem.AllowRead = true;
    } else {
      updatedItem.AllowRead = false;
    }

    if (formValues[`AllowWrite${Id}`]) {
      updatedItem.AllowWrite = true;
    } else {
      updatedItem.AllowWrite = false;
    }

    data.accessInfoValues.push({
      ...item,
      ...updatedItem,
    });
  });

  return data;
};



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/helpers/serialize.js